import React from 'react';
import { Navbar } from '../components/Navbar';
import { NoirAtelierSection } from '../components/NoirAtelierSection';
import { Footer } from '../components/Footer';
export function NoirAtelierPage() {
  return <div className="w-full min-h-screen bg-dark-900 text-white" data-id="element-294">
      <Navbar data-id="element-295" />
      <main data-id="element-296">
        <NoirAtelierSection data-id="element-297" />
      </main>
      <Footer data-id="element-298" />
    </div>;
}